/* eslint-disable import/no-unused-modules */
import StartBlogGuide from 'components/StartBlog/StartBlogGuide';
import withApollo from '../lib/withApollo';

// Pillar page of the blogger-intent SEO cluster (docs/seo-plan.md §3).
const StartTravelBlogPage = () => <StartBlogGuide />;

export default withApollo(StartTravelBlogPage);
